import { render } from "./ThirdPartySettings.vue?vue&type=template&id=6be0f90e&scoped=true"
import script from "./ThirdPartySettings.vue?vue&type=script&lang=js"
export * from "./ThirdPartySettings.vue?vue&type=script&lang=js"

import "./ThirdPartySettings.vue?vue&type=style&index=0&id=6be0f90e&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be0f90e"]])

export default __exports__